import { render } from "./SidebarCampeonato.vue?vue&type=template&id=5e42b198&scoped=true"
import script from "./SidebarCampeonato.vue?vue&type=script&lang=js"
export * from "./SidebarCampeonato.vue?vue&type=script&lang=js"

import "./SidebarCampeonato.vue?vue&type=style&index=0&id=5e42b198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e42b198"]])

export default __exports__